import { useEffect, type ReactNode } from 'react';
import { Spinner } from '@components/base/feedback';
import { useClaimFlowAuthStore } from '../auth/store';
import { LoginPage } from '../pages/LoginPage';

interface ClaimFlowAuthGuardProps {
  children: ReactNode;
}

export function ClaimFlowAuthGuard({
  children,
}: Readonly<ClaimFlowAuthGuardProps>) {
  const isAuthenticated = useClaimFlowAuthStore(
    (state) => state.isAuthenticated,
  );
  const user = useClaimFlowAuthStore((state) => state.user);
  const fetchUser = useClaimFlowAuthStore((state) => state.fetchUser);

  useEffect(() => {
    if (isAuthenticated && !user) {
      fetchUser();
    }
  }, [isAuthenticated, user, fetchUser]);

  if (!isAuthenticated) {
    return <LoginPage />;
  }

  if (!user) {
    return (
      <div className="flex items-center justify-center h-screen">
        <Spinner size="lg" />
      </div>
    );
  }

  return <>{children}</>;
}
